import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center" }
const _hoisted_2 = { class: "w-full sm:w-8/12 border border-solid border-black hover:border-red-600 p-5 sm:p-8 hover:bg-gray-200" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "pb-5 font-bold" }, " If you would like to order parts, get a quote or have any other queries, please contact us below: ", -1)
const _hoisted_4 = { class: "pb-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "Phone: ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  class: "hover:text-red-600 hover:border-b hover:border-red-600",
  href: `tel:01 675 949`,
  target: "_blank"
}, "01 675 1949", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  class: "hover:text-red-600 hover:border-b hover:border-red-600",
  href: `tel:086 0400 320`,
  target: "_blank"
}, "086 0400 320", -1)
const _hoisted_8 = { class: "pb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, "WhatsApp: ", -1)
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("b", null, "Email: ", -1)
const _hoisted_12 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, [
        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'phone'] }),
        _createTextVNode(),
        _hoisted_5,
        _hoisted_6,
        _createTextVNode(" or "),
        _hoisted_7
      ]),
      _createElementVNode("p", _hoisted_8, [
        _createVNode(_component_font_awesome_icon, { icon: ['fab', 'whatsapp'] }),
        _createTextVNode(),
        _hoisted_9,
        _createElementVNode("a", {
          class: "hover:text-red-600 hover:border-b hover:border-red-600",
          href: `https://wa.me/353860400320`,
          target: "_blank"
        }, "086 0400 320", 8, _hoisted_10)
      ]),
      _createElementVNode("p", null, [
        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'envelope'] }),
        _createTextVNode(),
        _hoisted_11,
        _createElementVNode("a", {
          class: "hover:text-red-600 hover:border-b hover:border-red-600",
          href: `mailto:contact@themotorbikedoctor.com`,
          target: "_blank"
        }, "contact@themotorbikedoctor.com", 8, _hoisted_12)
      ])
    ])
  ]))
}